import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, IconButton, DialogTitle, DialogContent, Tabs, Tab, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Box } from '@mui/system'
import { toast } from 'react-toastify'

import './modalContacts.css'

import { Contacts } from './model'
import { SeccionGeneral } from './form/SeccionGeneral'
import { SeccionComercial } from './form/SeccionComercial'
import { SeccionContactos } from './form/SeccionContactos'
import { uploadFile } from '../../firebase/config'
import { iniGetListCustomers } from '../../redux/actions/contacts'

export const DialogProfileContact = ({ open, setOpen, initialState }) => {

    const dispatch = useDispatch();
    const { id_pais } = useSelector(state => state.general.info)
    const [openMas, setOpenMas] = useState(false)
    const [form, setForm] = useState(initialState)
    const [selectedImage, setSelectedImage] = useState(null)

    useEffect(() => {
        if (!form.id_pais) {

            setForm(prev => ({
                ...prev,
                id_pais: id_pais
            }))

        }
    }, [id_pais, form.id_pais])

    // const handleChange = ({ target }) => {
    //     setForm({
    //         ...form,
    //         [target.name]: target.value,
    //     });
    // }

    const handleChange = async ({ target }) => {
        const { name, value, type, checked } = target
        const newValue = (type === 'checkbox' ? checked : value)
        setForm({
            ...form,
            [name]: newValue
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (form.tipo === 'empresa' && (form.nombre_comercial === '' && form.razon_social === '')) {
            toast.warn("Ingrese al menos Nombre comercial o Razón social")
            return false
        }

        if (form.tipo === 'persona' && form.nombre === '') {
            toast.warn("Ingrese al menos Nombre")
            return false
        }

        if (form.id > 0) {

            let dataForm = form

            if (selectedImage) {
                const fileName = `contacto-${form.id}`
                const path = `foto_contactos/${fileName}`
                try {
                    const urlFoto = await uploadFile(selectedImage, path)
                    dataForm.url_foto = urlFoto
                } catch (error) {
                    console.log(error)
                    toast.error("Fallo al guardar foto. Intente nuevamente.")
                }
            }

            const dataUpdate = await Contacts.update(dataForm)
            setSelectedImage(null)

            setForm({
                ...form,
                url_foto: dataForm.url_foto,
                ultima_actualizacion: dataUpdate.ultima_actualizacion
            })

        } else {

            const id = await Contacts.save(form)
            setForm({
                ...form,
                id: id
            })

        }

        dispatch(iniGetListCustomers());

    }

    return (
        <Dialog
            className='dialogoContacs'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                <DialogTitle id="scroll-dialog-title">
                    Perfil del contacto
                    <IconButton
                        aria-label="close"
                        style={{ padding: '0', float: 'right' }}
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon style={{ color: '#78667E' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TabsContacto
                        form={form}
                        setForm={setForm}
                        openMas={openMas}
                        setOpenMas={setOpenMas}
                        handleChange={handleChange}
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                    />
                </DialogContent>
            </form>
        </Dialog>
    )
}

const TabsContacto = ({ form, setForm, openMas, setOpenMas, handleChange, selectedImage, setSelectedImage }) => {
    const [value, setValue] = React.useState(0);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: '1px solid #FCF1FF' }}>
                <Tabs value={value} onChange={handleChangeTab} aria-label="basic tabs example">
                    <Tab label="Información general" {...a11yProps(0)} style={{ textTransform: 'capitalize' }} />
                    <Tab label="Datos bancarios" {...a11yProps(1)} style={{ textTransform: 'capitalize', display: form.id > 0 ? '' : 'none' }} />
                    <Tab label="Contactos relacionados" {...a11yProps(2)} style={{ textTransform: 'capitalize', display: form.id > 0 ? '' : 'none' }} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <SeccionGeneral
                    form={form}
                    setForm={setForm}
                    openMas={openMas}
                    setOpenMas={setOpenMas}
                    handleChange={handleChange}
                    selectedImage={selectedImage}
                    setSelectedImage={setSelectedImage}
                />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <SeccionComercial
                    form={form}
                    setForm={setForm}
                    openMas={openMas}
                />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <SeccionContactos
                    form={form}
                    openMas={openMas}
                />
            </TabPanel>
        </Box >
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography component={'div'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}